import { render, staticRenderFns } from "./GCidcard.vue?vue&type=template&id=08c04691&scoped=true"
import script from "./GCidcard.vue?vue&type=script&lang=js"
export * from "./GCidcard.vue?vue&type=script&lang=js"
import style0 from "./GCidcard.vue?vue&type=style&index=0&id=08c04691&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c04691",
  null
  
)

export default component.exports